(() => {
  if (document.body.classList.contains("is-505")) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const tape = document.querySelector("[data-desk-tape]");
  const clock = document.querySelector("[data-desk-clock]");
  if (tape || clock) {
    const pad = (n, z = 2) => String(n).padStart(z, "0");
    const born = Date.now();
    const tick = () => {
      if (tape) {
        if (document.body.classList.contains("is-broken") && Math.random() > 0.96) {
          tape.textContent = `${pad(Math.floor(Math.random() * 99))}:${pad(Math.floor(Math.random() * 99))}:${pad(Math.floor(Math.random() * 99))}:${pad(Math.floor(Math.random() * 99))}`;
        } else {
          const elapsed = Date.now() - born;
          const s = Math.floor(elapsed / 1000);
          const h = Math.floor(s / 3600);
          const m = Math.floor((s % 3600) / 60);
          const sec = s % 60;
          const f = Math.floor((elapsed % 1000) / 40);
          tape.textContent = `${pad(h)}:${pad(m)}:${pad(sec)}:${pad(f)}`;
        }
      }
      if (clock) {
        const d = new Date();
        const ms = Math.floor(d.getMilliseconds() / 10);
        const t = (d.getHours() << 6) | d.getMinutes();
        const live = t === 375 || t === 1143;
        clock.textContent = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}:${pad(ms)}`;
        clock.classList.toggle("is-sig", live);
        document.body.classList.toggle("is-sig", live);
      }
    };
    tick();
    setInterval(tick, reduced ? 1000 : 40);
  }

  if (!reduced) {
    const faces = [...document.querySelectorAll(".desk-icon__play, .desk-icon__glyph")];
    if (faces.length) {
      setInterval(() => {
        if (Math.random() > 0.82) {
          const el = faces[Math.floor(Math.random() * faces.length)];
          el.classList.add("is-corrupt");
          setTimeout(() => el.classList.remove("is-corrupt"), 110);
        }
      }, 2600);
    }
  }

  const rooms = (window.FH && window.FH.rooms) || [];
  if (!rooms.length) return;
  const norm = (href) => {
    try {
      const p = new URL(href, location.origin).pathname.replace(/\/+$/, "");
      return p || "/";
    } catch (_) {
      return "/";
    }
  };
  const here = location.pathname.replace(/\/+$/, "") || "/";
  let i = rooms.findIndex((r) => {
    const p = norm(r.href);
    if (p === "/") return here === "/";
    return here === p || here.startsWith(p);
  });
  if (i < 0) i = 0;
  const last = document.querySelector("[data-desk-last]");
  const next = document.querySelector("[data-desk-next]");
  if (last) last.href = rooms[(i - 1 + rooms.length) % rooms.length].href;
  if (next) next.href = rooms[(i + 1) % rooms.length].href;
})();
